<template>
  <v-container fluid>
      <v-row>
          <v-col cols="12">
              <v-row
                align="center"
                justify="center"
              >   
                <v-card
                max-width="1200"
                :min-width=min_width
                flat
                class="d-none d-md-flex"
                >
                 <v-col cols="12" class="pb-0">
                            <v-container class="pb-0">
                                <v-row>
                                    <v-col cols="6" class="p-0">
                                        <div class="text-h3 text-lg-h2 primary--text text-center">
                                            Client
                                        </div>
                                    </v-col>
                                    <v-col cols="5" class="p-0">
                                        <div class="text-h3 text-lg-h2 primary--text text-center">
                                            Contact
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                </v-card>
                <v-card
                max-width="1200"
                :min-width=min_width
                outlined
                class="rounded-card"
                >
                    <v-row>
                        <v-col col=12>
                            <v-card-text class="pt-0 pb-0">
                                <v-radio-group
                                    v-model="formType" 
                                    row
                                    style="width=100%"
                                    @change="clearForm"
                                    >
                                      <v-col
                                      v-for="option in formOptions"
                                      :key="option.id"
                                      cols="12"
                                      md="6"
                                      >
                                        <v-radio :label="option.title" :value="option.val"></v-radio>  
                                     </v-col>
                                </v-radio-group>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <v-card-text class="pt-0 pb-0">
                                <v-container class="pt-0 pb-0">
                                    <v-form ref="form" @submit.prevent="submitClientForm">
                                        <v-row>
                                            <v-col cols="12" class="p-0 d-inline d-md-none">
                                                <div class="text-h4 primary--text text-center">
                                                    Client
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md=6 class="p-0" v-if="formType === 0">
                                                <v-text-field
                                                v-model="client_selected"
                                                label="* Client Name"
                                                ref="clientTextField"
                                                class="pa-0 ma-0"
                                                :rules="clientNameRules"
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" md=6 class="p-0" v-else-if="formType === 1">
                                                <v-autocomplete
                                                v-model="client_selected"
                                                label="* Client Name"
                                                :items=existingClientList
                                                item-text="client_name"
                                                item-value="client_id"
                                                ref="clientAutoComplete"
                                                class="pa-0 ma-0"
                                                return-object
                                                :rules="clientNameRules"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                            <v-col cols="12" md=5 class="p-0 d-none d-md-flex">
                                                <v-text-field 
                                                v-model="clientContext.contact.first_name"
                                                label="Contact First Name"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md=6 class="p-0 ">
                                                <v-text-field 
                                                v-model="clientContext.client.full_legal_company_name"
                                                label="Legal Company Name"
                                                class="pa-0 ma-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                             <v-col cols="12" md=5 class="p-0 d-none d-md-flex">
                                                <v-text-field 
                                                v-model="clientContext.contact.last_name"
                                                label="Contact Last Name"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md=6 class="p-0">
                                                <v-text-field
                                                v-model="clientContext.client.company_address"
                                                label="Address"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                            <v-col cols="12" md=5 class="p-0 d-none d-md-flex">
                                                <v-text-field 
                                                v-model="clientContext.contact.email"
                                                label="Contact Email"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols=12 md=6 class="p-0">
                                                <v-text-field 
                                                v-model="clientContext.client.company_city"
                                                label="City" 
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                            <v-col cols="5" class="p-0 d-none d-md-flex">
                                                <!--Spacer Column-->
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md=6 class="p-0">
                                                <v-text-field 
                                                v-model="clientContext.client.company_state"
                                                label="State" 
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                            <v-col cols="5" class="p-0 d-none d-md-flex">
                                                <!--Spacer Column-->
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols=12 md=6 class="p-0">
                                                <v-text-field 
                                                v-model="clientContext.client.company_zip"
                                                label="Zipcode"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                            <v-col cols="5" class="p-0 d-none d-md-flex">
                                                <!--Spacer Column-->
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols=12 md=6 class="p-0">
                                                <v-text-field 
                                                v-model="clientContext.client.company_phone"
                                                label="Phone Number"
                                                class="pa-0 ma-0"  
                                                v-mask="'(###) ###-####'"
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical class="d-none d-md-flex"></v-divider>
                                            <v-col cols="5" class="p-0 d-none d-md-flex">
                                                <!--Spacer Column-->
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols=12 md=6 class="p-0">
                                                <v-text-field 
                                                v-model="clientContext.client.company_fax"
                                                label="Fax Number"
                                                class="pa-0 ma-0"  
                                                v-mask="'(###) ###-####'"
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical></v-divider>
                                            <v-col cols="5" class="p-0 d-none d-md-flex">
                                                <!--Spacer Column-->
                                            </v-col>
                                            
                                        </v-row>
                                        
                                        <v-row>
                                            <v-col cols="12" md=6 class="p-0">
                                                <v-text-field 
                                                v-model="clientContext.client.company_website"
                                                label="Website"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="p-0 d-inline d-md-none">
                                                <div class="text-h4 primary--text text-center">
                                                    Company
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md=5 class="p-0 d-inline d-md-none">
                                                <v-text-field 
                                                v-model="clientContext.contact.first_name"
                                                label="Contact First Name"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md=5 class="p-0 d-inline d-md-none">
                                                <v-text-field 
                                                v-model="clientContext.contact.last_name"
                                                label="Contact Last Name"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md=5 class="p-0 d-inline d-md-none">
                                                <v-text-field 
                                                v-model="clientContext.contact.email"
                                                label="Contact Email"
                                                class="pa-0 ma-0" 
                                                ></v-text-field>
                                            </v-col>
                                            <v-divider vertical></v-divider>
                                            <v-col cols="12" md=5 class="p-lg-0">
                                                <v-container class="pl-xl-7 pr-xl-7" v-if="formType === 0">
                                                    <div>
                                                        <div class="caption red--text">* indicates required fields</div>
                                                        <v-btn type="submit" color="primary" dark>
                                                            <span>
                                                                Create New Opportunity
                                                            </span>
                                                            <v-icon right>mdi-keyboard-tab</v-icon>
                                                        </v-btn>
                                                    </div>
                                                    <v-spacer></v-spacer>
                                                    <v-dialog max-width="350" v-model="dialog" persistent>
                                                        <v-card>
                                                            <v-card-title class="headline">Success!</v-card-title>
                                                            <v-card-text>You have successfully added a new client opportunity.</v-card-text>
                                                            <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="lime-green darken-3" text @click="createOpportunity">Create Proposal</v-btn>
                                                            <v-btn color="lime-green darken-3" text @click="dialog = false">Back</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                </v-container>
                                                <v-container class="pl-xl-7 pr-xl-7" v-else-if="formType === 1">
                                                    <div>
                                                        <div class="caption red--text">* indicates required fields</div>
                                                        <v-btn type="submit" color="primary" dark>
                                                            <span>
                                                                Update
                                                            </span>
                                                            <v-icon right>mdi-keyboard-tab</v-icon>
                                                        </v-btn>
                                                    </div>
                                                    <v-spacer></v-spacer>
                                                    <v-dialog max-width="350" v-model="dialog" persistent>
                                                        <v-card v-if="this.client_selected.plan_opportunity_id === null">
                                                            <v-card-title class="headline">Success!</v-card-title>
                                                            <v-card-text>You have successfully updated the information for your client.</v-card-text>
                                                            <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="lime-green darken-3" text @click="createOpportunity">Create Proposal</v-btn>
                                                            <v-btn color="lime-green darken-3" text @click="dialog = false">Back</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                        <v-card v-else>
                                                            <v-card-title class="headline" color="amber">This Client Already Has An Open Opportunity!</v-card-title>
                                                            <v-card-text>You can close the old opportunity or you can update the current opportunity.</v-card-text>
                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="lime-green darken-3" text @click="getOpportunity">Update</v-btn>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="lime-green darken-3" text @click="dialog = false">Back</v-btn>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="lime-green darken-3" text @click="closeCreateOpportunity">Close & Create New</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-card>
              </v-row>
          </v-col>
      </v-row>
  </v-container>
</template>
<style scoped>
.push-to-bottom {
    position: absolute;
    bottom: 0;
    left: 330px;
    margin: 24px
}
</style>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import {getTPAID} from '@/store/global_helpers/sessionReturn.js';
  export default {
    props: {
        clients: [Array, Object]
    },

    mounted(){
        window.scrollTo(0, 0);
        this.clearProposalBuilderState();
        this.clearPlanOpportunityViewModelState();
        this.clearProposalViewModels();

        let entity =  {
            type: 'tpa',
            id: getTPAID()
        }        
        this.getUserList(entity)
    },

    // beforeDestroy() {
        // this.clearProposalBuilderState();
        // this.clearPlanOpportunityViewModelState();
        // this.clearProposalViewModels();
    // },
    
    data: () => ({
        submitStatus: null,
        existingClientList: [],
        client_selected: '',
        clientContext: {
            plan_id: null, // Used to store plan id of existing client from drop down select
            client: {
                client_id: '',
                client_name: '',
                company_address: '',
                company_city: '',
                company_state: '',
                company_zip: '',
                company_phone: '',
                company_fax: '',
                company_website: '',
                company_type: '',
                full_legal_company_name: ''
            },
            contact: {
                email: '',
                phone: '',
                first_name: '',
                last_name: '',
            }
        },
        dialog: false,
        clientNameRules: [
            v => (v && v.length <= 100 && typeof v !== "object") || 'Name must be 100 characters or less',
        ],
        formType: 0,
        formOptions: {
            newClient: {
                id: 0,
                title: 'New Client',
                val: 0,
            },
            existingClient: {
                id: 1,
                title: 'Use Existing Client',
                val: 1,
            }
        }
        
    }),
    
    watch: {

      clients(){
        if(this.clients !== undefined){
            this.existingClientList = [];
            this.clients.forEach(item => {
                item.client.plan_opportunity_id = item.plan_opportunity_id;
                this.existingClientList.push(item.client);
            });
        }
      },

      client_selected(){
          this.$refs.form.resetValidation()
          if(this.client_selected.client_id !== undefined){
              this.getClient(this.client_selected.client_id);              
          } else {
              this.clientContext.client.client_name = this.client_selected
          }
      },

      contact(){
          if(this.contact !== null && this.contact !== undefined) {
                  this.clientContext.contact['contact_id'] = this.client_selected.contact_id
                  this.clientContext.contact.email = this.contact.email;
                  this.clientContext.contact.phone = this.contact.phone;
                  this.clientContext.contact.first_name = this.contact.first_name;
                  this.clientContext.contact.last_name = this.contact.last_name;
              }
      },

      client(){
          if(this.client !== null && this.client !== undefined && this.client_selected.client_id !== undefined){
              this.clientContext.client.client_id = this.client.client_id
              this.clientContext.client.client_name = this.client.client_name;
              this.clientContext.client.company_address = this.client.company_address;
              this.clientContext.client.company_city = this.client.company_city;
              this.clientContext.client.company_state = this.client.company_state;
              this.clientContext.client.company_zip = this.client.company_zip;
              this.clientContext.client.company_phone = this.client.company_phone;
              this.clientContext.client.company_fax = this.client.company_fax;
              this.clientContext.client.company_website = this.client.company_website;
              this.clientContext.client.company_type = this.client.company_type;
              this.clientContext.client.full_legal_company_name = this.client.full_legal_company_name
          }
      },

    },
    
    computed: {
        ...mapGetters({ client: 'readClient', contact: 'readContact'}),
        
        min_width () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return 200;
              case 'sm': return 400;
              case 'md': return 800;
              case 'lg': return 800;
              case 'xl': return 1200;
            }
            return null
        },
    },
    
    methods: {
        ...mapActions([
            'clearProposalBuilderState',
            'clearPlanOpportunityViewModelState',
            'clearProposalViewModels',
            'createClient',
            'getUserList',
            'getClient', 
            'updateClient', 
            'closeCreatePlanopportunity', 
            'createPlanopportunity', 
            'getPlanOpportunity']),
        
        // handleInput (newData) {
        //   this.$nextTick(() => {
        //     if(newData && newData.value){
        //       this.value = newData.value
        //     } else if(newData) {
        //       this.value = newData
        //     } else {
        //       this.value = null
        //     }
        //   })  
        // },

        submitClientForm() {
            console.log('submitClientForm called');
            switch(this.formType){
                case 0: //New client
                    console.log('submitClientForm (POST /client/)')
                    this.$refs.form.validate()
                    if (!this.$refs.form.inputs[0].hasError) {
                        this.dialog = true;
                        this.$refs.clientTextField.blur();
                        this.createClient(this.clientContext);
                    }
                    break;
                case 1: //Existing client
                    console.log('submitClientForm (PUT /client/)');
                    this.dialog = true;
                    this.$refs.form.resetValidation();
                    this.updateClient(this.clientContext);
                    this.getPlanId();
                    break;
            }
        },
        
        getPlanId(){
            console.log('getPlanId called');
            this.clients.forEach(c => {
                if (c.client.client_id === this.client_selected.client_id){
                    this.clientContext.plan_id = c.plan_opportunity_id;
                    console.log('this.clientContext.plan_id: '+this.clientContext.plan_id)
                }
            });
        },
        
        createOpportunity(){
            console.log('createOpportunity called')
            this.createPlanopportunity(this.client);
            this.routeToBuilder();
        },
        
        getOpportunity(){
            console.log('getOpportunity called');
            this.getPlanOpportunity(this.clientContext.plan_id)
            this.routeToBuilder();
        },
        
        closeCreateOpportunity(){
            console.log('closeCreateOpportunity called');
            this.getPlanId();
            this.closeCreatePlanopportunity({'client_id':this.client_selected.client_id,'plan_id':this.clientContext.plan_id})
            this.routeToBuilder();
        },

        routeToBuilder(){
            this.$router.push({
                name: 'proposal', 
                params: {
                    context: this.clientContext,
                    showComp: 'Builder', 
                    showUpdate: false
                }}
            );
        },
        
        clearForm(){
            this.client_selected = '';
            this.clientContext.client.client_id = '';
            this.clientContext.client.client_name = '';
            this.clientContext.client.company_address = '';
            this.clientContext.client.company_city = '';
            this.clientContext.client.company_state = '';
            this.clientContext.client.company_zip = '';
            this.clientContext.client.company_phone = '';
            this.clientContext.client.company_fax = '';
            this.clientContext.client.company_website = '';
            this.clientContext.client.company_type = '';
            this.clientContext.client.full_legal_company_name = '';
            this.clientContext.contact.contact_id = '';
            this.clientContext.contact.email = '';
            this.clientContext.contact.phone = '';
            this.clientContext.contact.first_name = '';
            this.clientContext.contact.last_name = '';
        }
    }
  };
</script>
<style type="text/css" scoped>
    .theme--light.v-sheet--outlined {
        border: thin solid rgb(0,0,0,30%);
    }
    .rounded-card {
        border-radius: 40px !important;
        box-shadow: 0px 0px 5px -2px;
    }
</style>
